import React, { useEffect, useState } from 'react';
import FramePlayer from '../utils/FramePlayer';
import anime from 'animejs';
import '../css/common.css';
import '../css/button.css';
import ImageButton from '../utils/ImageButton';
import Piano from '../utils/Piano';
import lang from '../lang.json';

const Module3f = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module3f;

    const [boxSelected1, setBoxSelected1] = useState([false, false]);
    const [boxSelected2, setBoxSelected2] = useState([false, false]);
    const [boxSelected3, setBoxSelected3] = useState([false, false]);
    const [boxSelected4, setBoxSelected4] = useState([false, false]);
    const [boxSelected5, setBoxSelected5] = useState([false, false]);
    const [boxSelected6, setBoxSelected6] = useState([false, false]);
    const [boxSelected7, setBoxSelected7] = useState([false, false]);
    const [boxSelected8, setBoxSelected8] = useState([false, false]);
    const [boxSelected9, setBoxSelected9] = useState([false, false]);

    const animCallback1 = (time, paused) => {
        console.log(time);
        if (time >= 15.41 && time < 17.2) {
            let boxSelected1Copy = [...boxSelected1];
            boxSelected1Copy[0] = true;
            setBoxSelected1(boxSelected1Copy);
        } else {
            let boxSelected1Copy = [...boxSelected1];
            boxSelected1Copy[0] = false;
            setBoxSelected1(boxSelected1Copy);
        }
        if (time >= 0.13 && time < 2.24) {
            let boxSelected2Copy = [...boxSelected2];
            boxSelected2Copy[0] = true;
            setBoxSelected2(boxSelected2Copy);
        } else {
            let boxSelected2Copy = [...boxSelected2];
            boxSelected2Copy[0] = false;
            setBoxSelected2(boxSelected2Copy);
        }
        if (time >= 41.47 && time < 43) {
            let boxSelected3Copy = [...boxSelected3];
            boxSelected3Copy[0] = true;
            setBoxSelected3(boxSelected3Copy);
        } else {
            let boxSelected3Copy = [...boxSelected3];
            boxSelected3Copy[0] = false;
            setBoxSelected3(boxSelected3Copy);
        }
        if (time >= 24.08 && time < 24.74) {
            let boxSelected4Copy = [...boxSelected4];
            boxSelected4Copy[0] = true;
            setBoxSelected4(boxSelected4Copy);
        } else {
            let boxSelected4Copy = [...boxSelected4];
            boxSelected4Copy[0] = false;
            setBoxSelected4(boxSelected4Copy);
        }
        if (time >= 14.22 && time < 15.34) {
            let boxSelected5Copy = [...boxSelected5];
            boxSelected5Copy[0] = true;
            setBoxSelected5(boxSelected5Copy);
        } else {
            let boxSelected5Copy = [...boxSelected5];
            boxSelected5Copy[0] = false;
            setBoxSelected5(boxSelected5Copy);
        }
        if (time >= 24.74 && time < 30.36) {
            let boxSelected6Copy = [...boxSelected6];
            boxSelected6Copy[0] = true;
            setBoxSelected6(boxSelected6Copy);
        } else {
            let boxSelected6Copy = [...boxSelected6];
            boxSelected6Copy[0] = false;
            setBoxSelected6(boxSelected6Copy);
        }
        if (time >= 31.82 && time < 33.73) {
            let boxSelected7Copy = [...boxSelected7];
            boxSelected7Copy[0] = true;
            setBoxSelected7(boxSelected7Copy);
        } else {
            let boxSelected7Copy = [...boxSelected7];
            boxSelected7Copy[0] = false;
            setBoxSelected7(boxSelected7Copy);
        }
        if (time >= 30.62 && time < 31.75) {
            let boxSelected8Copy = [...boxSelected8];
            boxSelected8Copy[0] = true;
            setBoxSelected8(boxSelected8Copy);
        } else {
            let boxSelected8Copy = [...boxSelected8];
            boxSelected8Copy[0] = false;
            setBoxSelected8(boxSelected8Copy);
        }
        if (time >= 23.68 && time < 24.08) {
            let boxSelected9Copy = [...boxSelected9];
            boxSelected9Copy[0] = true;
            setBoxSelected9(boxSelected9Copy);
        } else {
            let boxSelected9Copy = [...boxSelected9];
            boxSelected9Copy[0] = false;
            setBoxSelected9(boxSelected9Copy);
        }
    }

    const animCallback2 = (time, paused) => {
        console.log(time);
        if (time >= 0.03 && time < 1.71) {
            let boxSelected1Copy = [...boxSelected1];
            boxSelected1Copy[1] = true;
            setBoxSelected1(boxSelected1Copy);
        } else {
            let boxSelected1Copy = [...boxSelected1];
            boxSelected1Copy[1] = false;
            setBoxSelected1(boxSelected1Copy);
        }
        if (time >= 1.71 && time < 2.82) {
            let boxSelected2Copy = [...boxSelected2];
            boxSelected2Copy[1] = true;
            setBoxSelected2(boxSelected2Copy);
        } else {
            let boxSelected2Copy = [...boxSelected2];
            boxSelected2Copy[1] = false;
            setBoxSelected2(boxSelected2Copy);
        }
        if (time >= 2.82 && time < 4.31) {
            let boxSelected3Copy = [...boxSelected3];
            boxSelected3Copy[1] = true;
            setBoxSelected3(boxSelected3Copy);
        } else {
            let boxSelected3Copy = [...boxSelected3];
            boxSelected3Copy[1] = false;
            setBoxSelected3(boxSelected3Copy);
        }
        if (time >= 4.31 && time < 9.16) {
            let boxSelected4Copy = [...boxSelected4];
            boxSelected4Copy[1] = true;
            setBoxSelected4(boxSelected4Copy);
        } else {
            let boxSelected4Copy = [...boxSelected4];
            boxSelected4Copy[1] = false;
            setBoxSelected4(boxSelected4Copy);
        }
        if (time >= 9.16 && time < 10.23) {
            let boxSelected5Copy = [...boxSelected5];
            boxSelected5Copy[1] = true;
            setBoxSelected5(boxSelected5Copy);
        } else {
            let boxSelected5Copy = [...boxSelected5];
            boxSelected5Copy[1] = false;
            setBoxSelected5(boxSelected5Copy);
        }
        if (time >= 10.23 && time < 15.23) {
            let boxSelected6Copy = [...boxSelected6];
            boxSelected6Copy[1] = true;
            setBoxSelected6(boxSelected6Copy);
        } else {
            let boxSelected6Copy = [...boxSelected6];
            boxSelected6Copy[1] = false;
            setBoxSelected6(boxSelected6Copy);
        }
        if (time >= 15.23 && time < 16.34) {
            let boxSelected7Copy = [...boxSelected7];
            boxSelected7Copy[1] = true;
            setBoxSelected7(boxSelected7Copy);
        } else {
            let boxSelected7Copy = [...boxSelected7];
            boxSelected7Copy[1] = false;
            setBoxSelected7(boxSelected7Copy);
        }
        if (time >= 16.34 && time < 18.15) {
            let boxSelected8Copy = [...boxSelected8];
            boxSelected8Copy[1] = true;
            setBoxSelected8(boxSelected8Copy);
        } else {
            let boxSelected8Copy = [...boxSelected8];
            boxSelected8Copy[1] = false;
            setBoxSelected8(boxSelected8Copy);
        }
        if (time >= 18.15 && time < 21.24) {
            let boxSelected9Copy = [...boxSelected9];
            boxSelected9Copy[1] = true;
            setBoxSelected9(boxSelected9Copy);
        } else {
            let boxSelected9Copy = [...boxSelected9];
            boxSelected9Copy[1] = false;
            setBoxSelected9(boxSelected9Copy);
        }
    }

    useEffect(() => {
        //Hide all the boxes
        for (let i = 1; i <= 9; i++) {
            let boxes = document.getElementsByClassName("box" + i);
            for (let j = 0; j < boxes.length; j++) {
                boxes[j].style.opacity = 0;
            }
        }
        //Show every 600ms a new box, coloring it in orange for 400ms
        let tl = anime.timeline({})
        for (let i = 1; i <= 9; i++) {
            tl.add({
                targets: '.box' + i,
                opacity: 1,
                backgroundColor: "rgba(252, 166, 53, 0.6)",
                duration: 300,
                easing: 'easeOutElastic(1, .8)',
            }, 300)
                .add({
                    targets: '.box' + i,
                    backgroundColor: "rgba(235, 194, 99, 0.3)",
                    duration: 300,
                    easing: 'easeOutElastic(1, .8)',
                }, 300)
        }
    }, []);

    return (<>
        <div className="background" >

            <Piano
                dirName={"piano3f1"}
                numberOfPages={1}
                pageSpeeds={[43]} //duree de la page
                musicName={"piano3f1"}
                callback={animCallback1}
                style={{ position: 'absolute', top: '100px' }}
            />
            <Piano
                dirName={"piano3f2"}
                numberOfPages={1}
                pageSpeeds={[21]} //duree de la page
                musicName={"piano3f2"}
                width={550} 
                callback={animCallback2}
                style={{ position: 'absolute', top: '300px', left: '0px' }}
            />

            {/*transparent box piano2*/}
            <div
                className='box1'
                style={{
                    position: 'absolute',
                    top: '360px',
                    left: '11px',
                    width: "53px",
                    height: "70px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected1[0] || boxSelected1[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box2'
                style={{
                    position: 'absolute',
                    top: '342px',
                    left: '56px',
                    width: "62px",
                    height: "70px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected2[0] || boxSelected2[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box3'
                style={{
                    position: 'absolute',
                    top: '336px',
                    left: '85px',
                    width: "42px",
                    height: "70px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected3[0] || boxSelected3[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box4'
                style={{
                    position: 'absolute',
                    top: '340px',
                    left: '123px',
                    width: "125px",
                    height: "75px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected4[0] || boxSelected4[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box5'
                style={{
                    position: 'absolute',
                    top: '386px',
                    left: '249px',
                    width: "26px",
                    height: "44px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected5[0] || boxSelected5[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box6'
                style={{
                    position: 'absolute',
                    top: '335px',
                    left: '277px',
                    width: "152px",
                    height: "105px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected6[0] || boxSelected6[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box7'
                style={{
                    position: 'absolute',
                    top: '366px',
                    left: '410px',
                    width: "50px",
                    height: "68px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected7[0] || boxSelected7[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box8'
                style={{
                    position: 'absolute',
                    top: '351px',
                    left: '437px',
                    width: "55px",
                    height: "74px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected8[0] || boxSelected8[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box9'
                style={{
                    position: 'absolute',
                    top: '335px',
                    left: '486px',
                    width: "72px",
                    height: "77px",
                    border: "1px solid black",
                    zIndex: boxSelected9[0] || boxSelected9[1] ? 9 : 8,
                    backgroundColor: boxSelected9[0] || boxSelected9[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />

            {/*transparent box piano1*/}
            <div
                className='box1'
                style={{
                    position: 'absolute',
                    top: '140px',
                    left: '243px',
                    width: "25px",
                    height: "70px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected1[0] || boxSelected1[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box2'
                style={{
                    position: 'absolute',
                    top: '128px',
                    left: '11px',
                    width: "31px",
                    height: "70px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected2[0] || boxSelected2[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box3'
                style={{
                    position: 'absolute',
                    top: '133px',
                    left: '637px',
                    width: "21px",
                    height: "59px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected3[0] || boxSelected3[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box4'
                style={{
                    position: 'absolute',
                    top: '123px',
                    left: '374px',
                    width: "72px",
                    height: "81px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected4[0] || boxSelected4[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box5'
                style={{
                    position: 'absolute',
                    top: '160px',
                    left: '224px',
                    width: "18px",
                    height: "44px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected5[0] || boxSelected5[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box6'
                style={{
                    position: 'absolute',
                    top: '118px',
                    left: '383px',
                    width: "85px",
                    height: "98px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected6[0] || boxSelected6[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box7'
                style={{
                    position: 'absolute',
                    top: '149px',
                    left: '491px',
                    width: "28px",
                    height: "68px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected7[0] || boxSelected7[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box8'
                style={{
                    position: 'absolute',
                    top: '156px',
                    left: '473px',
                    width: "31px",
                    height: "70px",
                    border: "1px solid black",
                    zIndex: boxSelected8[0] || boxSelected8[1] ? 9 : 8,
                    backgroundColor: boxSelected8[0] || boxSelected8[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                className='box9'
                style={{
                    position: 'absolute',
                    top: '133px',
                    left: '367px',
                    width: "40px",
                    height: "67px",
                    border: "1px solid black",
                    zIndex: boxSelected9[0] || boxSelected9[1] ? 9 : 8,
                    backgroundColor: boxSelected9[0] || boxSelected9[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />

            <img src={process.env.PUBLIC_URL + "/assets/images/module3f/1.jpg"}
                alt="image"
                style={
                    { position: "absolute", right: 5, top: 320 }}
            />

            <div
                style={{
                    position: 'absolute',
                    top: '246px',
                    left: '0px',
                    width: "660px",
                    height: "10px",
                    zIndex: 10,
                    backgroundColor: "rgba(0, 0, 0, 0.3)"
                }}
            />

            <div
                style={{
                    position: 'absolute',
                    top: '446px',
                    left: '0px',
                    width: "560px",
                    height: "10px",
                    zIndex: 10,
                    backgroundColor: "rgba(0, 0, 0, 0.3)"
                }}
            />

            {/* textes */}
            <p
                style={{
                    position: 'absolute',
                    left: 10,
                    top: 0,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang1}</p>
            <p
                style={{
                    position: 'absolute',
                    left: 20,
                    top: 26,
                    color: 'white',
                    fontSize: '15px',
                    width: 600,
                    zIndex: 15
                }}
            >{texts.lang30}</p>
            <p
                style={{
                    position: 'absolute',
                    right: 10,
                    top: 56,
                    color: '#3398ff',
                    fontSize: '18px',
                    zIndex: 15
                }}
            >{texts.lang31}</p>
            <p
                style={{
                    position: 'absolute',
                    left: 526,
                    top: 256,
                    color: 'red',
                    fontSize: '18px',
                    zIndex: 15
                }}
            >{texts.lang32}</p>
        </div>
    </>
    );
}

export default Module3f;